export const SUGGESTIONS = [
  "Marketing landing page",
  "Personal blog with Tailwind",
  "Website for local bakery",
  "Company website with pricing",
];
